"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ensureCase = void 0;
const objects_1 = require("../objects");
const caseChanger = {
    camelCase: objects_1.convertKeysToCamelCase,
    snake_case: objects_1.convertKeysToSnakeCase,
};
const ensureCase = (object, keyCase) => {
    if (!keyCase)
        return object;
    // Case changer function
    const cc = caseChanger[keyCase];
    // Return if no case changer
    if (!cc)
        return object;
    // change the case of keys
    return cc(object);
};
exports.ensureCase = ensureCase;
